/**
 * What each realistic biome needs from the network before the shared scene
 * can draw it on this page. Pure data so `node --test` can check it.
 *
 * Mirrors `courseVegetationGeometry` in packages/putt-scene: Cedar Ridge
 * meshes its trees from the cedar set, the palm and desert biomes grow
 * theirs procedurally, and every other biome (including The Links' oaks)
 * draws from the woodland species. The foliage branch atlas dresses all of
 * them except the storm's dead trees; the clubhouse atlases are never
 * fetched because clubhouses are off on every hole.
 */
import type { RealisticSceneryId } from '../../../packages/putt-scene/src/realistic/index';
import type { RawRgbaAssetKey } from '../../../packages/putt-scene/src/assets';
import type { StageGraphics } from './quality';

export type BakedTreeSet = 'cedar' | 'woodland';

const MESHED_FROM: Readonly<Record<RealisticSceneryId, BakedTreeSet | null>> = {
  cedar: 'cedar',
  island: null,
  desert: null,
  links: 'woodland',
  city: 'woodland',
  alpine: 'woodland',
  pine: 'woodland',
  autumn: 'woodland',
  twilight: 'woodland',
  storm: 'woodland',
};

export function biomeTreeSet(sceneryId: RealisticSceneryId): BakedTreeSet | null {
  return MESHED_FROM[sceneryId] ?? null;
}

export function biomeAtlasKeys(sceneryId: RealisticSceneryId, graphics: StageGraphics): RawRgbaAssetKey[] {
  if (sceneryId === 'storm') return [];
  return [graphics === 'reduced' ? 'foliage-branches-v1-reduced' : 'foliage-branches-v1'];
}
